// Personel › performans sekmelerinin (Çalışan Performansı, Tedavi Metrikleri,
// Hasta İletişimi) ortak kabuğu — docs/design-principles.md §4: slate50 zemin,
// üstte tüm sekmeye uygulanan dönem seçici, altında KPI satırı ve kartlar.
import React from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import PeriodSelector from "../../components/common/PeriodSelector";
import { useClinicTheme } from "../../theme";
import { COLORS, TYPO, CARD_GAP, CARD_PAGE_PAD } from "../../styles/uiConstants";

export const PERIOD_LABELS = {
  today: "Bugün",
  this_week: "Bu hafta",
  this_month: "Bu ay",
  last_30_days: "Son 30 gün",
};

/**
 * Yalnız geliştirmede (npm start) durum önizlemesi: URL'ye `&onizleme=` ekle.
 *   bos        → veri yok (kart içi boş durumlar)
 *   yukleniyor → yükleme iskeleti
 * Production build'de yok sayılır (PatientDistributionTab ile aynı kalıp).
 */
export function usePreviewState() {
  const [searchParams] = useSearchParams();
  if (process.env.NODE_ENV !== "development") return null;
  const v = searchParams.get("onizleme");
  return v === "bos" || v === "yukleniyor" ? v : null;
}

/** KPI satırı: 4 kutucuk (xs'de 2'li). */
export const kpiGridSx = {
  display: "grid",
  gap: CARD_GAP,
  gridTemplateColumns: { xs: "1fr 1fr", lg: "repeat(4, 1fr)" },
};

/** Kart gövdesinde kayan liste alanı (ince scrollbar, sayfaya taşmaz). */
export const scrollAreaSx = {
  height: "100%",
  overflowY: "auto",
  overscrollBehavior: "contain",
  pr: 1,
  mr: -1,
  "&::-webkit-scrollbar": { width: 6, height: 6 },
  "&::-webkit-scrollbar-thumb": { bgcolor: COLORS.slate200, borderRadius: 3 },
};

/** Sekme kabı: üst şerit (dönem notu + dönem seçici) + içerik. */
export function PerformanceTabFrame({ period, onPeriodChange, note, children }) {
  const { palette } = useClinicTheme();
  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: COLORS.slate50,
        ...CARD_PAGE_PAD,
        display: "flex",
        flexDirection: "column",
        gap: CARD_GAP,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1.5,
        }}
      >
        <Typography sx={{ fontSize: TYPO.body, color: COLORS.slate500 }}>
          <Box component="span" sx={{ color: COLORS.slate700, fontWeight: 600 }}>
            {PERIOD_LABELS[period] || "Seçili dönem"}
          </Box>
          {note ? ` · ${note}` : ""}
        </Typography>
        {onPeriodChange ? (
          <PeriodSelector
            value={period}
            onChange={onPeriodChange}
            palette={palette}
            variant="segmented"
          />
        ) : null}
      </Box>
      {children}
    </Box>
  );
}
